import { Button, ButtonBorderRadius, ButtonTheme } from '@apply/components';
import {
    BrokerAgreementSummary,
    useUpdateBrokerAgreementEntityMutation,
} from '../../../../../../../queries/brokerAgreementQueries';

interface UpdateEntityButtonProps {
    summary: BrokerAgreementSummary;
    /** The entity chosen in PrimaryEntityField. */
    primaryEntityId: number | null;
}

/** Saves the chosen primary entity straight away (not with the loan); disabled while a save is in progress. */
export const UpdateEntityButton = ({ summary, primaryEntityId }: UpdateEntityButtonProps) => {
    const updateEntity = useUpdateBrokerAgreementEntityMutation();

    const saveEntity = () => {
        const primaryEntity = summary.borrowerEntities?.find((entity) => entity.entityId === primaryEntityId);
        if (!primaryEntity) {
            return;
        }
        updateEntity.mutate({
            brokerAgreementId: summary.brokerAgreementId,
            entityId: primaryEntity.entityId,
            entityName: primaryEntity.entityName,
        });
    };

    return (
        <Button
            id='brokerAgreementUpdateEntity'
            theme={ButtonTheme.Tertiary}
            borderRadius={ButtonBorderRadius.Small}
            disabled={updateEntity.isPending}
            handleClick={saveEntity}
            height='36px'
        >
            Update Entity
        </Button>
    );
};
